
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'EducationBase',

  computed: {
    ...mapState(['isOnboardingShown']),

    isMainEducationPage() {
      return this.$route.path === '/education'
    },

    isNPSCalled() {
      return this.$store.state.notices.isNPSCardClicked
    },

    isNPSShowing() {
      return (
        (this.isOnboardingShown && this.isMainEducationPage) || this.isNPSCalled
      )
    },

    isHideMenu() {
      return this.$route.path.includes('/trajectories')
    }
  },

  mounted() {
    const isDev = process.env.NODE_ENV !== 'production'
    if (!this.$store.state.user.jwtToken && !isDev) {
      window.location.replace('https://gb.ru/login')
    }
  },

  beforeDestroy() {
    if (this.isNPSCalled) {
      this.$store.commit('notices/set', {
        type: 'isNPSCardClicked',
        payload: false
      })
    }
  }
}
